import { fontStyles } from './font-styles/font-styles.js';
import { focusStyles } from './focus-styles/focus-styles.js';
import { themeColor } from './theme-color/theme-color.js';
import { linearGradient, radialGradient, gradient } from './gradient/gradient.js';
import { smallerThan, largerThan } from './breakpoints/breakpoints.js';
import { rgba } from './rgba/rgba.js';
import { cover } from './cover/cover.js';
import { darken } from './darken/darken.js';
import { lighten } from './lighten/lighten.js';
import { radius } from './radius/radius.js';
import { variant } from './variant/variant.js';
import { primaryShade } from './primary-shade/primary-shade.js';
import { primaryColor } from './primary-color/primary-color.js';
import { hover } from './hover/hover.js';
import { placeholderStyles } from './placeholder-styles/placeholder-styles.js';
import { dimmed } from './dimmed/dimmed.js';

const fns = {
  fontStyles,
  themeColor,
  focusStyles,
  linearGradient,
  radialGradient,
  smallerThan,
  largerThan,
  rgba,
  cover,
  darken,
  lighten,
  radius,
  variant,
  primaryShade,
  hover,
  gradient,
  primaryColor,
  placeholderStyles,
  dimmed
};

export { fns };
//# sourceMappingURL=index.js.map
